import { render } from "./CSRPage.vue?vue&type=template&id=d1cbeac2&scoped=true"
import script from "./CSRPage.vue?vue&type=script&lang=js"
export * from "./CSRPage.vue?vue&type=script&lang=js"

import "./CSRPage.vue?vue&type=style&index=0&id=d1cbeac2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1cbeac2"]])

export default __exports__